import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx } from "vue"

import { ref, onMounted, computed } from 'vue';
import { BaseDialog, BaseTextContent } from 'xrk-components';
import { basicInformation } from '@V/invoice/src/data-source/apis';
import { BasicInformationData } from '@V/invoice/src/data-source/types';
import InvoiceEnterpriseDialogInfo from './invoice-enterprise-dialog-info.vue';
import InvoiceEnterpriseDialogAddress from './invoice-enterprise-dialog-address.vue';
import InvoiceEnterpriseDialogCategory from './invoice-enterprise-dialog-category.vue';
import InvoiceEnterpriseDialogClient from './invoice-enterprise-dialog-client.vue';

import appStore from '@/store';
import { entpTypeEnum } from '@/common/constants/company/index';
import { storeToRefs } from 'pinia';


export default /*#__PURE__*/_defineComponent({
  __name: 'invoice-enterprise-dialog',
  props: {
    remove: { type: Function, default() {
      return () => {
        console.log('remove');
      };
    } }
  },
  setup(__props: any) {



const { defaultUserFnCode } = storeToRefs(appStore.useUserStoreSetup);
const isIndustry = computed(() => defaultUserFnCode.value === entpTypeEnum.GY);

const formData = ref<BasicInformationData>({
  addressList: [],
  itemList: [],
  baseInfo: {
    entpName: '',
    entpCertNo: '',
    phone: '',
    bankName: '',
    openBankNumber: '',
    companyBusinessAddress: '',
    demand: ''
  },
  clientList: []
});

onMounted(async () => {
  const { data } = await basicInformation();
  formData.value = data;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseDialog), {
    width: "950px",
    class: "form-dialog form-dialog--label120 form-dialog-invoice-enterprise",
    title: "开票维护",
    "model-value": true,
    "close-on-press-escape": true,
    "close-on-click-modal": false,
    cancelBtnConfig: {
      show: false
    },
    confirmBtnConfig: { show: false }
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(BaseTextContent), null, {
        default: _withCtx(() => [
          _createVNode(InvoiceEnterpriseDialogInfo, {
            value: formData.value.baseInfo
          }, null, 8, ["value"]),
          _createVNode(InvoiceEnterpriseDialogAddress, {
            value: formData.value.addressList
          }, null, 8, ["value"]),
          (!isIndustry.value)
            ? (_openBlock(), _createBlock(InvoiceEnterpriseDialogCategory, {
                key: 0,
                value: formData.value.itemList
              }, null, 8, ["value"]))
            : _createCommentVNode("", true),
          (formData.value.clientList && formData.value.clientList.length)
            ? (_openBlock(), _createBlock(InvoiceEnterpriseDialogClient, {
                key: 1,
                value: formData.value.clientList
              }, null, 8, ["value"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})